import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Payout.css';
import getAllWeeklyPayouts from './getAllWeeklyPayouts.graphql';
import PayoutManagement from '../../../components/SiteAdmin/PayoutManagement/PayoutManagement';
import Loader from '../../../components/Common/Loader/Loader';
import messages from '../../../locale/messages'
class Payout extends React.Component {

  static propTypes = {
    weeklyPayoutData: PropTypes.shape({
      loading: PropTypes.bool
    })
  };

  static defaultProps = {
    weeklyPayoutData: {
      loading: true
    }
  };

  render() {
    const { formatMessage } = this.props.intl;
    const { weeklyPayoutData, weeklyPayoutData: { loading } } = this.props;
    return (
      <Loader type={"page"} show={loading}><div className={s.root}>
        <div className={s.container}>
          <div className={s.heading}>
            {formatMessage(messages.payoutManagementLabel)}
          </div>
          <div className={s.paddingRoutesSection}>
            {<PayoutManagement weeklyPayoutData={weeklyPayoutData} />}
          </div>
        </div>
      </div></Loader>
    )
  }
}

export default compose(injectIntl,
  withStyles(s),
  graphql(getAllWeeklyPayouts, {
    name: 'weeklyPayoutData',
    options: (props) => ({
      variables: {
        currentPage: 1,
        searchList: '',
        payoutStatus: props.payoutStatus ? props.payoutStatus : false,
        dates: props.dates ? props.dates : null
      },
      fetchPolicy: 'network-only'
    }),
  })
)(Payout);